import * as R from 'ramda';

import type { AccountSelectOption } from 'lib/hooks/useAccountSelectOptions';

export const getAccountFromOptions = (options: AccountSelectOption[], id: string) =>
  R.find(R.propEq('value', id), options);
